<template>
  <div id="app">
    <div id="nav">
      <div id="title" @click="$router.push('/')">
        <img src="./img/newLogo4.png" style="height: 75px" />
      </div>

      <el-menu
        :default-active="activeIndex"
        class="el-menu-demo"
        mode="horizontal"
        @select="handleSelect"
        background-color="#add8e6"
        text-color="#000"
        active-text-color="#7caf46"
        style="margin-left: 20px"
      >
        <el-menu-item index="/" style="height: 100px" class="menu-item-centered"
          >Home</el-menu-item
        >
        <el-submenu index="/Expression/index" style="height: 100px">
          <template slot="title">Tools</template>
          <el-menu-item
            index="/Expression/index"
            style="font-weight: bold; font-size: 18px"
            >Prediction</el-menu-item
          >
          <el-menu-item index="/go" style="font-weight: bold; font-size: 18px"
            >GO</el-menu-item
          >
          <el-menu-item
            index="/blash"
            style="font-weight: bold; font-size: 18px"
            >Blast</el-menu-item
          >
        </el-submenu>
        <el-menu-item
          index="/search"
          style="height: 100%"
          class="menu-item-centered"
          >Search</el-menu-item
        >
        <el-submenu index="/result/predictions" style="height: 100%">
          <template slot="title">Results</template>
          <el-menu-item
            index="/result/predictions"
            style="font-weight: bold; font-size: 18px"
            >Predictions</el-menu-item
          >
          <el-menu-item
            index="/result/gradent"
            style="font-weight: bold; font-size: 18px"
            >Gradent Distract</el-menu-item
          >
          <el-menu-item
            index="/result/heatmap"
            style="font-weight: bold; font-size: 18px"
            >Heat Map</el-menu-item
          >
          <el-menu-item
            index="/result/validation"
            style="font-weight: bold; font-size: 18px"
            >Validation</el-menu-item
          >
          <el-menu-item
            index="/result/motifs"
            style="font-weight: bold; font-size: 18px"
            >Motifs Enichment</el-menu-item
          >
        </el-submenu>
        <!-- <el-menu-item
          index="/Browser"
          style="height: 100%"
          class="menu-item-centered"
          >Browser</el-menu-item
        > -->
        <el-menu-item
          index="/tutorial"
          style="height: 100%"
          class="menu-item-centered"
          >Tutorial</el-menu-item
        >
        <el-menu-item
          index="/about"
          style="height: 100%"
          class="menu-item-centered"
          >Contact</el-menu-item
        >
      </el-menu>
    </div>

    <!-- <section class="featured1"></section> -->
    <div class="main">
      <router-view />
    </div>
    <div class="foot">
      <div style="display: flex; width: 80%; margin: 0 auto">
        <div style="flex: 1">
          <h3 style="color: #fff; font-size: 1rem; font-weight: 500">
            POWERED BY
          </h3>
          <el-row>
            <el-col :span="24">
              <a href="http://www.hzau.edu.cn/" target="_blank">
                <img
                  src="./img/footImg/hzau_logo_h100.png"
                  alt=""
                  class="img-fluid"
                />
              </a>
            </el-col>
          </el-row>
        </div>

        <div style="flex: 7; text-align: center">
          <el-row :gutter="40" type="flex" justify="center">
            <el-col :span="3">
              <a href="https://maizegdb.org/" target="_blank">
                <img
                  src="./img/footImg/maizeGDB.png"
                  alt=""
                  class="img-fluid"
                />
              </a>
            </el-col>
            <el-col :span="3">
              <a href="http://maizego.org/index.html" target="_blank">
                <img
                  src="./img/footImg/maizego_h100.png"
                  alt=""
                  class="img-fluid"
                />
              </a>
            </el-col>
            <el-col :span="4">
              <a href="https://db.cngb.org/zeamap" target="_blank">
                <img src="./img/footImg/ZEAMAPlogo.svg" alt="" class="img-fluid" />
                <span
              class="text-bold col-auto"
              style="font-size: 14px;color :#74c195;font-weight: bolder ;"
              >ZEAMAP</span
            >
              </a>
            </el-col>
            <el-col :span="3">
              <a href="https://meme-suite.org/meme/index.html" target="_blank">
                <img src="./img/footImg/MEME.png" alt="" class="img-fluid" />
              </a>
            </el-col>
            <el-col :span="3">
              <a href="http://planttfdb.gao-lab.org/index.php" target="_blank">
                <img
                  src="./img/footImg/PlantTFDB.png"
                  alt=""
                  class="img-fluid"
                />
              </a>
            </el-col>
            <el-col :span="3">
              <a href="http://rice.hzau.edu.cn/rice_rs2/" target="_blank">
                <img
                  src="./img/footImg/Rice-data-logo.png"
                  alt=""
                  class="img-fluid"
                />
              </a>
            </el-col>
            <el-col :span="3">
              <a href="http://www.deepcba.com" target="_blank">
                <img
                  src="./img/footImg/deepcba.png"
                  alt=""
                  class="img-fluid"
                />
              </a>
            </el-col>
          </el-row>
        </div>
      </div>
      <p
        style="width: 80%; text-align: center; margin: 0 auto; padding: 10px 0"
      >
        Huazhong Agricultural university, Wuhan, 430070, China&nbsp;&nbsp;
          <a href="https://beian.mps.gov.cn/#/query/webSearch?code=42011102005355" rel="noreferrer" target="_blank">鄂公网安备42011102005965号</a>
          &nbsp;&nbsp;<a href="https://beian.miit.gov.cn/" rel="noreferrer" target="_blank">鄂ICP备2023020828号-2</a>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeIndex: "1",
    };
  },
  mounted() {},
  methods: {
    onClick({ key }) {
      this.$router.push(`/tools/${key}`);
      console.log(this.$router);
      console.log(`Click on item ${key}`);
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
      this.$router.push(key);
    },
    visibleChange(visible) {
      console.log(visible);
    },
  },
};
</script>

<style>
body {
  margin: 0;
}
#app {
  font-family: Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 1000px;
  margin: 0 auto;
  min-width: 1500px; /* 检查这一行 */
}

.dropdown-content {
  display: none;
  position: absolute;
  background-color: #f9f9f9;
  min-width: 160px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
}

.show {
  display: block;
}

.el-menu--horizontal > .el-submenu .el-submenu__title {
  height: 100px !important;
  line-height: 100px !important;
}

#nav .el-menu-demo {
  flex: 1;
  display: flex;
  justify-content: center;
}

.el-menu-demo ul {
  margin-left: 50px;
}

.el-menu-demo {
  font-family: 'Open Sans', sans-serif;
  font-weight: 400;
}

.el-menu-demo li {
  max-width: 250px;
  flex: 1;
  text-align: center;
  font-size: 25px !important;
  font-weight: bold;
}

.menu-item-centered {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%; /* 继承父容器高度 */
}

.el-menu-demo div {
  flex: 1;
  text-align: center;
  font-size: 25px !important;
  font-weight: bold;
}

#title {
  text-shadow: 3px 3px 8px rgba(255, 255, 255, 0.5);
  cursor: pointer;
  display: flex;
  align-items: center;
  cursor: pointer;
}

#nav {
  line-height: 100px;
  background-color: #add8e6;
  margin-bottom: 0;
  padding-left: 150px;
  padding-right: 150px;
  padding-bottom: 0;
  display: flex;
  height: 100px;
}

#nav a {
  font-weight: bold;
  font-size: 25px;
  color: #fff;
}

#nav .link-wrapper {
  flex: 1;
}

.link-wrapper {
  display: flex;
  justify-content: center;
}

.link-wrapper a {
  max-width: 250px;
  flex: 1;
  text-align: center;
}

#tool a {
  height: 50px;
  font-weight: bold;
  font-size: 20px;
  color: #42b983;
}
#nav a.router-link-exact-active {
  color: #42b983;
}
.foot {
  bottom: 0px;
  background-color: #26232b;
  color: white;
  height: 160px;
  padding-top: 2em;
}

.img-fluid {
  max-width: 100%;
  height: auto;
}

#title {
  margin-left: -100px; /* 例如，向左移动20像素 */
  text-shadow: 3px 3px 8px rgba(255, 255, 255, 0.5);
  cursor: pointer;
  display: flex;
  align-items: center;
}
</style>
